import React, { useMemo } from 'react';

import { useLocale } from 'shared/presentation/contexts';

import appStoreSvg from './assets/appstore.svg';
import googlePlaySvg from './assets/google-play.svg';
import * as S from './styles';

type TAppStoreIconsProps = {
  className?: string;
  size?: S.TAppStoreIconsSize;
};

const AppStoreIcons: React.FC<TAppStoreIconsProps> = ({
  className,
  size = 'default',
}) => {
  const { t } = useLocale('shared');

  const STORE_LINKS = useMemo(
    () => [
      {
        key: 'playStore',
        url: 'https://play.google.com/store/apps/details?id=com.cheesecakelabs.vialaser.prod',
        title: t('App at google play'),
        image: googlePlaySvg,
      },
      {
        key: 'appStore',
        url: 'https://apple.co/2Aqm7rN',
        title: t('App at appstore'),
        image: appStoreSvg,
      },
    ],
    [t],
  );

  return (
    <S.Container className={className} size={size}>
      {STORE_LINKS.map(({ key, url, title, image }) => (
        <a key={key} href={url} rel="noopener noreferrer" title={title}>
          <img src={image} alt={title} loading="lazy" />
        </a>
      ))}
    </S.Container>
  );
};

export default AppStoreIcons;
